module.exports = __webpack_public_path__ + "static/media/header_home_biolitoral_bi_2.70d7c7e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/header_home_biolitoral_bi_2.png
// module id = 667
// module chunks = 0